import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { NotificationType } from 'common/enums';
import { useContext } from 'react';
import {
  vaultDetailActions,
  VaultDetailContext,
} from 'context/vault-detail-context';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { appActions, AppContext } from 'context';
import { NotificationObject } from 'models/notificationObject';
import EmptyAlbumsBackgroundImage from 'assets/images/empty-albums-background.png';

export const EmptyAlbumsState = () => {
  const { state, dispatch } = useContext(VaultDetailContext);
  const { dispatch: generalDispatch } = useContext(AppContext);

  const handleCreateNewAlbumFromScratch = async () => {
    try {
      const newAlbum = await VaultsController.createAlbum(state.vaultId);
      dispatch({
        type: vaultDetailActions.ADD_TO_UNANSWERED,
        album: newAlbum,
      });
      dispatch({
        type: vaultDetailActions.SET_ACTIVE_ALBUM,
        activeAlbumPointer: {
          id: newAlbum.id,
          listType: 'unanswered',
        },
      });
      generalDispatch({
        type: appActions.NOTIFICATION,
        notification: new NotificationObject({
          show: true,
          title: 'New album created',
          type: NotificationType.Success,
        }),
      });
    } catch (error) {
      generalDispatch({
        type: appActions.NOTIFICATION,
        notification: new NotificationObject({
          show: true,
          title: 'Failed to create new album',
          message: 'Please try again',
          type: NotificationType.Error,
        }),
      });
    }
  };

  return (
    <div className="h-[254px] w-full overflow-hidden rounded-[14px] bg-white">
      <div className="box-border flex h-full w-full flex-col items-center justify-center gap-3 overflow-hidden px-5 py-4">
        <img
          alt="empty-albums"
          src={EmptyAlbumsBackgroundImage}
          className="h-auto max-h-[150px] w-auto max-w-[347px] shrink-0 object-contain object-center"
        />
        <div className="flex max-w-[300px] shrink-0 flex-col items-center justify-center gap-2 overflow-hidden text-center">
          <span className="text__body__regular__medium__gray700">
            Let&apos;s build your Albums.
          </span>
          <span className="text__body__regular__small__gray500">
            Start by choosing a Topic from the list or{' '}
            <Button
              buttonSize={ButtonSize.Small}
              buttonStyle={ButtonStyle.PrimaryGhostLink}
              onClick={handleCreateNewAlbumFromScratch}
            >
              create an Album
            </Button>{' '}
            from scratch.
          </span>
        </div>
      </div>
    </div>
  );
};
